<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="website">
      <div class="page-container">
        <div class="page-title-item">
          <div class="title-item active">分站管理</div>
        </div>
        <websiteBuildComponent v-if="userInfo.FzLevel < 50" />
        <websiteInfoComponent v-else />
        <div class="auth-list-container">
          <div class="table-item">
            <div class="tr thead">
              <div class="td">套餐权限</div>
              <div class="td" v-for="(vip, index) in vipList" :key="index">{{ vip.Name }}/{{ vip.Money }}元</div>
            </div>
            <div class="tr" v-for="(auth, authIndex) in authList" :key="authIndex">
              <div class="td">{{ auth.Title }}</div>
              <div class="td" v-for="(vip, index) in vipList" :key="index">
                <img v-if="auth['Vip' + vip.Level] == 1" src="../../assets/pc-images/auth-active-icon.png" />
                <img v-else src="../../assets/pc-images/auth-icon.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </pcUserNavComponent>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'
import websiteBuildComponent from './WebsiteBuildComponent'
import websiteInfoComponent from './WebsiteInfoComponent'

export default {
  name: "User",
  components: {
    pcTabBarComponent,
    pcUserNavComponent,
    websiteBuildComponent,
    websiteInfoComponent,
  },
  data() {
    return {
      vipList: [],
      authList: [],
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  mounted() {
    this.handleGetAuthList()
    this.handleGetVipList()
  },
  methods: {
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    async handleGetAuthList() {
      var res = await this.$API.substationsAuthList.post()
      this.authList = res
    },
    async handleGetVipList() {
      var res = await this.$API.vipMoney.post({
        Type: 2
      })
      if (res && res.length > 0) {
        this.vipList = res
      }
    },
  },
}

</script>

<style lang="less" scoped>
.page-container {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px;
  overflow: hidden;
}
.page-title-item {
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  .title-item {
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
.auth-list-container {
  padding: 25px 16px;
  .table-item {
    border-top: 1px solid #a6a6a6;
    border-left: 1px solid #a6a6a6;
    .tr {
      display: flex;
      align-items: center;
      justify-content: center;
      &.thead {
        background-color: #f5f7fa;
        .td {
          height: 100px;
        }
      }
      .td {
        flex: 1;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        border-bottom: 1px solid #a6a6a6;
        border-right: 1px solid #a6a6a6;
        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}
</style>